import React, { Component } from 'react';
import { formatNumber } from 'utils';
import cn from 'classnames';
import styles from './Price.scss';

import Button from '../../../../common/Button/Button';
import Switcher from '../../../../common/Switcher/Switcher';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';

const digits = (number) => (number ? formatNumber(number) : '...');
const inputDigits = (number) => {
  const parsed = parseInt(number, 10);
  return Number(number) === '0' || isNaN(parsed) ? '' : formatNumber(parsed);
};

export const parseSearch = (search) => {
  const { costMin, costMax, priceMin, priceMax } = search;
  if (priceMin || priceMax) {
    return {
      valueMin: priceMin ? String(priceMin) : '',
      valueMax: priceMax ? String(priceMax) : '',
      isChecked: false
    };
  }
  return {
    valueMin: costMin ? String(costMin) : '',
    valueMax: costMax ? String(costMax) : '',
    isChecked: true
  };
};

export const compileSearch = (data) => {
  const { valueMin, valueMax, isChecked } = data;
  const min = valueMin ? Number(valueMin) : undefined;
  const max = valueMax ? Number(valueMax) : undefined;
  return isChecked
    ? { costMin: min, costMax: max, priceMin: undefined, priceMax: undefined }
    : { costMin: undefined, costMax: undefined, priceMin: min, priceMax: max };
};

export const compileRequest = compileSearch;

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { valueMin, valueMax, isChecked } = parseSearch(search);
  if (valueMin || valueMax) {
    if (isChecked) {
      let valueMaxFin,
        valueMinFin;
      if ((parseFloat(valueMax) % 1000000 == 0) && (parseFloat(valueMin) % 1000000 == 0)) {
        valueMaxFin = i18n.t('components.header.filtersBar.filters.price.cost', {
          price: valueMax.substring(0, valueMax.length - 6)
        });
        valueMinFin = i18n.t('components.header.filtersBar.filters.price.cost', {
          price: valueMin.substring(0, valueMin.length - 6)
        });
        return `${valueMinFin} - ${valueMaxFin}`;
      } else if (parseFloat(valueMax) % 1000000 == 0) {
        valueMaxFin = i18n.t('components.header.filtersBar.filters.price.cost', {
          price: valueMax.substring(0, valueMax.length - 6)
        });
        return `${digits(valueMin)} - ${valueMaxFin}`;
      } else if (parseFloat(valueMin) % 1000000 == 0) {
        valueMinFin = i18n.t('components.header.filtersBar.filters.price.cost', {
          price: valueMin.substring(0, valueMin.length - 6)
        });
        return `${valueMinFin} - ${digits(valueMax)}`;
      }
      return `${digits(valueMin)} - ${digits(valueMax)}`;
    }

    return i18n.t('components.header.filtersBar.filters.price.perMeter', {
      min: digits(valueMin),
      max: digits(valueMax)
    });
  }
  return i18n.t('components.header.filtersBar.filters.price.notSelected');
};

class Input extends Component {

  getRef = (ref) => {
    this.ref = ref;
  }

  componentDidMount() {
    this.updateValue();
  }

  componentDidUpdate() {
    this.updateValue();
  }

  updateValue = () => {
    const oldLength = this.ref.value.length;
    const oldIdx = this.ref.selectionStart;
    this.ref.value = this.props.value;
    if (document.activeElement === this.ref) {
      const newIdx = Math.max(0, this.ref.value.length - oldLength + oldIdx);
      this.ref.selectionStart = this.ref.selectionEnd = newIdx;
    }
  }

  render() {
    const { checked } = this.props;
    return <input ref={this.getRef} {...this.props} value={undefined} maxLength={checked ? 11 : 8} />;
  }
}

class Price extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ...parseSearch(props.search)
    };

    this.handleMinValueChange = this.handleMinValueChange.bind(this);
    this.handleMaxValueChange = this.handleMaxValueChange.bind(this);
    this.handleClearButtonClick = this.handleClearButtonClick.bind(this);
    this.handleSwitcherClick = this.handleSwitcherClick.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
  }

  handleMinValueChange(event) {
    const valueMin = this.parseValue(event.target.value);
    const cb = (valueMin !== this.state.valueMin) ? this.updateSearch : _ => _;
    this.setState({ valueMin }, cb);
  }

  handleMaxValueChange(event) {
    const valueMax = this.parseValue(event.target.value);
    const cb = (valueMax !== this.state.valueMax) ? this.updateSearch : _ => _;
    this.setState({ valueMax }, cb);
  }

  handleClearButtonClick() {
    this.setState({ valueMin: '', valueMax: '' }, this.updateSearch);
  }

  handleSwitcherClick(checked) {
    const { valueMin, valueMax } = this.state;
    this.setState({ isChecked: checked }, () => {
      if (valueMin || valueMax) {
        this.updateSearch();
      }
    });
  }

  updateSearch() {
    const { dropdownData } = this.props;
    const compiled = compileSearch(this.state);
    dropdownData(compiled, compiled);
  }

  parseValue(value) {
    const parsed = Number(parseInt(value.replace(/\s/g, ''), 10));
    return value ? (isNaN(parsed) ? undefined : parsed) : undefined;
  }

  render() {
    const { className, chessfilter, events, eventData, t } = this.props;
    const { isChecked, valueMin, valueMax } = this.state;

    return (
      <div className={cn(styles.Menu, className, { [styles.MenuChessfilter]: chessfilter })}>
        <p className={styles.Title}>
          {!chessfilter ? t('components.header.filtersBar.filters.price.title') : null}

          <Switcher
            onClick={this.handleSwitcherClick}
            defaultChecked={isChecked}
            enabledColor="#085286"
            events={events}
            eventData={eventData}
            leftText={chessfilter
              ? t('components.header.filtersBar.filters.price.commonPriceWithCurrency')
              : t('components.header.filtersBar.filters.price.commonPrice')
            }
            rightText={chessfilter
              ? t('components.header.filtersBar.filters.price.commonPriceMeterWithCurrency')
              : t('components.header.filtersBar.filters.price.commonPriceMeter')
            }
            className={cn(styles.Switcher)}
            chessfilter={chessfilter}
          />
        </p>

        <div className={styles.Inner}>
          <div className={styles.Inputs}>
            <Input
              value={inputDigits(valueMin)}
              onChange={this.handleMinValueChange}
              className={styles.Input}
              placeholder={t('components.header.filtersBar.filters.price.from')}
              checked={isChecked}
            />
            <span className={styles.Dash}> – </span>
            <Input
              value={inputDigits(valueMax)}
              onChange={this.handleMaxValueChange}
              className={styles.Input}
              placeholder={t('components.header.filtersBar.filters.price.to')}
              checked={isChecked}
            />
          </div>
          {
            !!(valueMin || valueMax) &&
            <Button className={cn(styles.Button)} onClick={this.handleClearButtonClick}>
              {t('components.header.filtersBar.filters.price.clear')}
            </Button>
          }
        </div>
      </div>
    );
  }
}

export default withTranslation()(Price);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Price/Price.js